export const apiPathPublic = `_api/cloud-css-server`
export const cssFileName = 'masterPage.css'
export const apiPathDS = `_api/cloud-css-dev-server`
export const customCssId = 'wix-custom-css'
